/* eslint-disable no-useless-escape */
import _ from 'lodash';
import { ssoFormTypes } from '../../components/utils/form-types';
import { apiConstants } from './api-constants';

const rxOne = /^[\],:{}\s]*$/;
const rxTwo = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
const rxThree = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
const rxFour = /(?:^|:|,)(?:\s*\[)+/g;
export const isJSON = (input) => (
    input.length && rxOne.test(
        input.replace(rxTwo, '@')
            .replace(rxThree, ']')
            .replace(rxFour, '')
    )
);

export function handleResponse(response) {
    let responseText = {};
    return response.text().then((text) => {
        responseText = text;
        return { hasErrors: true, statusCode: response.status, responseText };
    }).then(() => {
        const parsedResponse = isJSON(responseText) ? JSON.parse(responseText) : responseText;
        if (!_.isEmpty(parsedResponse) && !_.isEmpty(parsedResponse.errors)) {
            return { hasErrors: true, statusCode: response.status, errorMessage: Object.values(parsedResponse.errors) };
        }

        if (response.ok) {
            return { hasErrors: false, data: parsedResponse };
        }

        return { hasErrors: true, statusCode: response.status, errorMessage: parsedResponse };
    });
}

export function handleBlobResponse(response) {
    const reader = response.body.getReader();
    const result = [];

    return reader.read()
        .then(
            function processText({ done, value }) {
                if (done) {
                    const blob = new Blob(result, { type: 'application/pdf' });
                    const videoUrl = URL.createObjectURL(blob);
                    window.open(videoUrl);
                    return { hasErrors: false };
                }

                result.push(value);

                return reader.read().then(processText);
            }
        );
}

// TODO: add different kind of logging
export function handleError(error) {
    // eslint-disable-next-line no-console
    console.error('API call failed. ' + error);
    return { hasErrors: true, errorMessage: 'Network error.' };
}

export function redirect(redirectUrl) {
    window.location = redirectUrl;
}

export function getFormDataUrl(formType) {
    if (formType === ssoFormTypes.BallotFullRegister) { return apiConstants.loadFullBallotRegisterFormDataUrl; }

    if (formType === ssoFormTypes.BallotLiteRegister) { return apiConstants.loadLiteBallotRegisterFormDataUrl; }

    if (formType === ssoFormTypes.RaMembersRegisterForm) { return apiConstants.loadRaMembersRegisterFormDataUrl; }

    return apiConstants.loadOneClubRegisterFormDataUrl;
}
